export default __webpack_public_path__ + "static/media/Chinease.dc902213.mp3";